import { Link, useLocation, useNavigate } from "react-router-dom";
import { Moon, Sparkles, LogOut } from "lucide-react";
import { ThemeToggle } from "./ThemeToggle";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

function UserMenu({ user, onLogout, onLogin }) {
  if (!user) {
    return (
      <Button
        data-testid="header-login-btn"
        size="sm"
        className="rounded-full cta-gradient text-white font-semibold hover:opacity-90"
        onClick={onLogin}
      >
        Log in
      </Button>
    );
  }
  return (
    <div className="flex items-center gap-3">
      <span className="hidden md:inline text-sm text-muted-foreground">{user.name || user.email}</span>
      <Button data-testid="logout-btn" variant="ghost" size="sm" onClick={onLogout}>
        <LogOut size={16} />
      </Button>
    </div>
  );
}

export function Header() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const navButton = (to, label, testid) => (
    <Button
      data-testid={testid}
      size="sm"
      variant={location.pathname === to ? "default" : "outline"}
      className="rounded-full font-semibold"
      onClick={() => navigate(to)}
    >
      {label}
    </Button>
  );

  return (
    <header
      data-testid="main-header"
      className="sticky top-0 z-50 border-b border-border glass"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5">
          <span className="relative flex h-9 w-9 items-center justify-center rounded-xl cta-gradient">
            <Moon size={18} className="text-white" />
            <Sparkles size={10} className="absolute -top-0.5 -right-0.5 text-white" />
          </span>
          <span className="font-display text-lg font-extrabold tracking-tight">
            Night<span className="text-cta-gradient">Out</span>
          </span>
        </Link>

        <div className="flex items-center gap-6">
          <nav className="hidden sm:flex items-center gap-3">
            {navButton("/", "Planner", "nav-planner")}
            {user && navButton("/my-nights", "My Nights", "nav-my-nights")}
          </nav>

          <ThemeToggle />

          <UserMenu
            user={user}
            onLogin={() => navigate("/auth")}
            onLogout={() => {
              logout();
              navigate("/");
            }}
          />
        </div>
      </div>
    </header>
  );
}
